// import Pusher from 'pusher-js/react-native';
import { cluster, key } from '../config/Apis';
const Pusher = require('pusher-js');


export const pusher = new Pusher(key, {
    cluster: cluster,
});


